// Texto 23 (H) e texto 27/29: o + das telas que não são listas de fichas (Escritório, Estudos, Casa, Finanças, Documentos,
// Garantias) oferece "Item completo" (o de sempre) e "📝 Nota rápida": uma caixa igual à da aba Anotações, que abre na hora
// para escrever e depois fica na própria aba (em "Anotações recebidas"). Nada vai para o My Planner.
import { useState } from 'react';
import { View } from 'react-native';
import type { AbaId } from '../store/types';
import { useDoc } from '../store/store';
import { addBox, removeBox } from '../store/anotacoes';
import { useBotaoNovo } from '../lib/botaoNovo';
import { t } from '../lib/i18n';
import { ActionSheet, Sheet, type Action } from './ui';
import { ScrollArrastavel } from './Arrastar';
import { BoxCard, limparBlocosVazios } from './BoxCard';

/** Registra o + da tela com a escolha "Item completo" / "Nota rápida". Devolve o que precisa ficar na tela. */
export function useNovoComNota(aba: AbaId, item: { rotulo: string; fn: () => void } | null, extras: Action[] = [], rotulo?: string) {
  const [escolher, setEscolher] = useState(false);
  const [nota, setNota] = useState<string | null>(null);
  useBotaoNovo({ rotulo: rotulo ?? item?.rotulo ?? t('Nota rápida'), fn: () => setEscolher(true) });
  return (<>
    <ActionSheet title={t('Incluir')} actions={escolher ? [
      ...(item ? [{ label: '＋ ' + t('Item completo: {o}', { o: item.rotulo }), onPress: item.fn }] : []),
      ...extras,
      { label: '📝 ' + t('Nota rápida'), onPress: () => setTimeout(() => setNota(addBox('', aba)), 300) },
    ] : null} onClose={() => setEscolher(false)} />
    <NotaRapidaSheet id={nota} onClose={() => setNota(null)} />
  </>);
}

/** A nota recém-criada, aberta para escrever. Fechando vazia, ela some (não fica caixa em branco). */
function NotaRapidaSheet({ id, onClose }: { id: string | null; onClose: () => void }) {
  const box = useDoc('anotacoes').boxes.find(b => b.id === id);
  const fechar = () => {
    if (box) {
      const vazia = !box.title.trim() && box.blocks.every(bl => (bl.type === 'text' || bl.type === 'sub' ? !bl.text.trim() : bl.type === 'desenho' ? !(bl.tracos?.length || bl.quadro) : !bl.items.some(i => i.text.trim())));
      if (vazia) removeBox(box.id); else limparBlocosVazios(box.id);
    }
    onClose();
  };
  return (
    <Sheet visible={!!id && !!box} onClose={fechar} title={'📝 ' + t('Nota rápida')}>
      <ScrollArrastavel keyboardShouldPersistTaps="handled" contentContainerStyle={{ padding: 16, paddingBottom: 60 }}>
        {!!box && <View><BoxCard box={box} /></View>}
      </ScrollArrastavel>
    </Sheet>
  );
}
